const INFO = {
	main: {
		title: "Diego Ruiz Gil - Portfolio",
		name: "Diego Ruiz Gil",
		email: "diegoruiz037@gmail.com",
		logo: "../logo.png",
	},

	socials: {
		github: "https://github.com/DiegoRuizGil",
		linkedin: "https://www.linkedin.com/in/diego-ruiz-gil/",
		itchio: "https://diegorg64.itch.io/",
		bsky: "https://bsky.app/profile/diegorg64.bsky.social"
	},

	homepage: {
		title: "Software & Game Developer, specialized in Unity and C#",
		description:
			"I’m a C#/.NET Software Engineer and Game Developer focused on building clean, scalable, and maintainable systems.I specialize in Unity development, where I design gameplay systems, tools, and editor extensions that improve workflows and productivity. I care deeply about architecture, testing, and code quality, applying principles like Clean Architecture, SOLID, DDD, and TDD to create reliable and extensible solutions.",
	},

	about: {
		title: "I’m Tharindu N. I live in Sri Lanka, where I design the future.",
		description:
			"I've worked on a variety of projects over the years and I'm proud of the progress I've made. Many of these projects are open-source and available for others to explore and contribute to. If you're interested in any of the projects I've worked on, please feel free to check out the code and suggest any improvements or enhancements you might have in mind. Collaborating with others is a great way to learn and grow, and I'm always open to new ideas and feedback.",
	},

	works: [
		{
			title: "Viva Games Studio",
			description: "Worked on the maintenance and updates of Merge Robots, a mobile game developed in Unity.",
			timeframe: "Nov. 2024 - Dec. 2024",
			url: "https://www.vivastudios.com/",
			logo: "./viva-games-logo.png",
		},
		{
			title: "Ghenova Digital",
			description: "Developed an early prototype of a ship radar system in Unity.",
			timeframe: "Feb. 2023 - May 2023",
			url: "https://ghenova.com/digital/",
			logo: "./ghenova-logo.png",
		},
	],

	studies: [
		{
			title: "Master in Videogame Development",
			institution: "University of Málaga",
			timeframe: "2023 - 2025",
			logo: "./uma-logo.png",
		},
		{
			title: "Degree in Software Engineering",
			institution: "University of Seville",
			timeframe: "2019 - 2023",
			logo: "./us-logo.png",
		}
	],
};

export default INFO;
